import { render } from "./EventCard.vue?vue&type=template&id=26cea271&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=26cea271&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26cea271"

export default script